<div class="workflow-item" (mouseover)="showWorkflowItemDetails()" (mouseleave)="closeDialog()">
    <img src="{{action ? (action.default_picto ? pictoPrefix + 'actions/' + action.default_picto+'.svg': pictoPrefix + 'actions/' + action.action_name+'.svg') :
    (ingredient.default_picto ? pictoPrefix + 'ingredients/' + ingredient.default_picto+'.svg': pictoPrefix + 'ingredients/' + ingredient.ingredient_name+'.svg')}}">
    <div class="workflow-item-name">{{action ? action.action_name : ingredient.ingredient_name}}</div>
</div>
